const category = {
  id: "",
  handle: "",
  from: 0,
  size: 12,
  container: document.getElementById("product-grid"),
  sortBy: document.getElementById('SortBy'),
  spinnerList: document.querySelectorAll(".js-infinite-scroll"),
  isLoading: false,
  _suppressUrlSync: false,
  _initialized: false,
  _allowObserverPaging: true,
  hitsByProductId: new Map(),
  sortToUrlKey: {
    "best-selling": "reco",
    "price-descending": "price-desc",
    "price-ascending": "price-asc",
    "created-descending": "newest",
  },
  urlKeyToSort: {
    "reco": "best-selling",
    "price-desc": "price-descending",
    "price-asc": "price-ascending",
    "newest": "created-descending",
  },
  async initOrRestore(id) {
    if (this.hasUsefulUrlState()) {
      return this.restoreCategoryFromUrl(id);
    }
    return this.init(id);
  },
  async init (id) {
      this.id = id;
      this.container.innerHTML = ''
      this.from = 0
      this.sortBy.value = "best-selling"
      this.facets.container.innerHTML = ""
      console.log('Debug - carga desde init')
      await this.loadProducts()
      this.events()
  },
  async restoreCategoryFromUrl(id) {
    this._isRestoring = true;
    this._allowObserverPaging = false;
    this._suppressUrlSync = true;
    this.id = id;
    this.container.innerHTML = "";
    this.from = 0;
    this.facets.container.innerHTML = "";
    const url = new URL(window.location.href);
    const sortKey = url.searchParams.get("sort") || "reco";
    const loadedTarget = this.getUrlIntParam("loaded", 0);
    const sortValue = this.urlKeyToSort?.[sortKey] || "best-selling";
    this.sortBy.value = sortValue;
    const talla = this.getUrlMultiParam("talla").map(v => v.toUpperCase());
    const fit = this.getUrlMultiParam("fit").map(v => v.toUpperCase());
    const group = this.getUrlMultiParam("group").map(v => v.toUpperCase());
    const colorGroups = this.getUrlMultiParam("color");
    for (const f of this.facets.list) f.value = [];
    const setFacetValues = (field, valuesUpper) => {
      const idx = this.facets.list.findIndex(x => x.field === field);
      if (idx !== -1) this.facets.list[idx].value = Array.from(new Set(valuesUpper));
    };

    setFacetValues("skus.customFields.talla", talla);
    setFacetValues("customFields.custom-fits", fit);
    setFacetValues("customFields.custom-product_group_code", group);
    if (!this.facets.colorGroupsByField) this.facets.colorGroupsByField = {};
    const colorField = "customFields.custom-color";

    this.facets.colorGroupsByField[colorField] = new Set(colorGroups);

    const expandedColors = [];
    for (const g of colorGroups) {
      const keyA = (g ?? "").toString().trim();
      const keyB = keyA.toUpperCase();
      const list = COLOR_FILTER_MAP[keyA] || COLOR_FILTER_MAP[keyB] || [];
      for (const v of list) expandedColors.push((v ?? "").toString().toUpperCase().trim());
    }
    setFacetValues(colorField, expandedColors.filter(Boolean));
    console.log('Debug - Antes de loadFacets')
    await this.loadFacetsOnly();
    console.log('Debug - Después de loadFacets')
    await this.loadUntil(loadedTarget);
    setTimeout(() => {
      this.restoreScrollFromHistory();
    }, 100);
    this._suppressUrlSync = false;
    this._isRestoring = false;
    setTimeout(() => {
      this._allowObserverPaging = true;
    }, 0);
    this.events();
  },
  indexHits(hits = []) {
    for (const hit of hits) {
      if (!hit) continue;
      const pid = String(hit.productId ?? "");
      if (!pid) continue;
      this.hitsByProductId.set(pid, hit);
    }
  },
  savePlpHistoryState() {
    const current = history.state || {};
    const next = {
      ...current,
      __plp: {
        scrollY: window.scrollY || 0,
        loaded: this.from || 0,
        href: location.href,
        ts: Date.now(),
      },
    };
    history.replaceState(next, "", location.href);
  },
  getPlpHistoryState() {
    return history.state && history.state.__plp ? history.state.__plp : null;
  },
  bindPlpNavigationTracking() {
    document.addEventListener(
      "click",
      (e) => {
        const a = e.target?.closest?.("a[href]");
        if (!a) return;

        const href = a.getAttribute("href") || "";
        const isPdp = href.includes("/products/");
        if (isPdp) {
          this.savePlpHistoryState();
        }
      },
      true
    );
    window.addEventListener("pagehide", () => this.savePlpHistoryState());
  },
  async restoreScrollFromHistory() {
    const st = this.getPlpHistoryState();
    if (!st || !st.scrollY) return;
    const target = st.scrollY;
    const maxWaitMs = 2500;
    const start = performance.now();
    while (document.documentElement.scrollHeight < target + window.innerHeight) {
      if (performance.now() - start > maxWaitMs) break;
      await new Promise((r) => requestAnimationFrame(r));
    }

    window.scrollTo(0, target);
  },
  getUrlIntParam(key, fallback = 0) {
    const url = new URL(window.location.href);
    const raw = url.searchParams.get(key);
    const n = Number(raw);
    return Number.isFinite(n) && n >= 0 ? Math.floor(n) : fallback;
  },
  getUrlMultiParam(key) {
    const url = new URL(window.location.href);
    return url.searchParams.getAll(key).map(s => (s ?? "").toString().trim()).filter(Boolean);
  },
  hasUsefulUrlState() {
    const url = new URL(window.location.href);
    const p = url.searchParams;
    return (
      p.has("sort") ||
      p.has("loaded") ||
      p.has("color") ||
      p.has("talla") ||
      p.has("fit") ||
      p.has("group")
    );
  },
  setUrlParam(key, value) {
    const url = new URL(window.location.href);
    if (value == null || value === "") {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
    window.history.replaceState(window.history.state || {}, "", url);
  },
  resetPaginationStateInUrl() {
    this.setUrlParam("loaded", 0);
  },
  events () {
    this.spinnerList.forEach((spinner) => {
        const sectionObserver = new IntersectionObserver((entries) => {
          if (!this._allowObserverPaging) return;
          entries.forEach((entry) => {
            if (this._isRestoring) return;
            if (entry.isIntersecting) {
    console.log('Debug - carga desde observer')
                this.loadProducts()
            }
          });
        });
        sectionObserver.observe(spinner);
    });
    this.sortBy.addEventListener("change", () => {
      if (this._isRestoring) return;
      const urlSortKey = this.sortToUrlKey[this.sortBy.value] || "reco";
      this.setUrlParam("sort", urlSortKey);
      this.from = 0;
      this.container.innerHTML = "";
      this.resetPaginationStateInUrl();
      console.log('Debug - carga desde sort')
      this.loadProducts();
    });
  },
  facets: {
    container: document.querySelector(".facets__details__wrapper"),
    colorGroupsByField: {},
    fieldToParam: {
      "skus.customFields.talla": "talla",
      "customFields.custom-fits": "fit",
      "customFields.custom-product_group_code": "group",
      "customFields.custom-color": "color", // <- este es el facet que tratamos como "color group"
    },
    list: [
      {
        field: "skus.customFields.talla",
        value: [],
      },
      {
        field: "customFields.shasa-color",
        value: [],
      },
      {
        field: "customFields.custom-fits",
        value: [],
      },
      {
        field: "customFields.custom-product_group_code",
        value: [],
      },
      {
        field: "customFields.custom-color",
        value: [],
      },
    ],
    _getParamName(field) {
      return this.fieldToParam[field] || field;
    },

    _setURLParamMulti(params, key, values) {
      params.delete(key);
      for (const v of values) params.append(key, v);
    },

    syncURLFromState() {
      const url = new URL(window.location.href);
      const params = url.searchParams;

      Object.values(this.fieldToParam).forEach((paramName) => params.delete(paramName));

      for (const facet of this.list) {
        const field = facet.field;

        if (field === "customFields.shasa-color") continue;

        const param = this._getParamName(field);

        if (param === "color") {
          const set = this.colorGroupsByField[field];
          const groups = set ? Array.from(set) : [];
          if (groups.length) this._setURLParamMulti(params, param, groups);
          continue;
        }

        const values = Array.isArray(facet.value) ? facet.value.filter(Boolean) : [];
        if (values.length) this._setURLParamMulti(params, param, values);
      }

      window.history.replaceState(window.history.state || {}, "", url);
    },

    set(name, value, checked, isColor = false) {
      const facet = name.split(".").at(-1);
      const position = this.list.findIndex((f) => f.field.includes(facet));
      if (position === -1) return;

      const field = this.list[position].field;
      const valueUppercase = (value ?? "").toString().trim();
      const valueUppercaseNorm = valueUppercase.toUpperCase().trim();

      if (isColor) {
        if (!this.colorGroupsByField[field]) this.colorGroupsByField[field] = new Set();
        const groupLabel =
          COLOR_FILTER_MAP[valueUppercase] ? valueUppercase :
          COLOR_FILTER_MAP[valueUppercaseNorm] ? valueUppercaseNorm :
          valueUppercase; 

        if (checked) this.colorGroupsByField[field].add(groupLabel);
        else this.colorGroupsByField[field].delete(groupLabel);
      }

      const expandedValues = isColor
        ? (COLOR_FILTER_MAP[valueUppercase] ||
          COLOR_FILTER_MAP[valueUppercaseNorm] ||
          [valueUppercase])
            .map((v) => (v ?? "").toString().toUpperCase().trim())
            .filter(Boolean)
        : [valueUppercaseNorm];

      if (checked) {
        const current = new Set(this.list[position].value || []);
        expandedValues.forEach((v) => current.add(v));
        this.list[position].value = Array.from(current);
      } else {
        const toRemove = new Set(expandedValues);
        this.list[position].value = (this.list[position].value || []).filter(
          (v) => !toRemove.has(v)
        );

      }

      category.logSelectedFilters();
      category.updateFilterBadges();

      if (!category._suppressUrlSync) {
        this.syncURLFromState();
      }
    },

    applyFilters() {
      if (category._isRestoring) return;
      category.from = 0;
      category.container.innerHTML = "";
      category.resetPaginationStateInUrl();
      this.syncURLFromState();
      console.log('Debug - carga desde filtros')
      category.loadProducts();
    },
  },
  logSelectedFilters () {
    const selectedFilters = {};
    let hasFilters = false;
    this.facets.list.forEach((facet) => {
      if (facet.value.length > 0) {
        selectedFilters[facet.field] = facet.value;
        hasFilters = true;
      }
    });
    console.info('Filtros seleccionados:', selectedFilters);
    
    const applyBtn = this.facets.container?.parentElement?.querySelector('button[type="button"].facets__submit');
    if (applyBtn) {
      if (hasFilters) {
        applyBtn.classList.remove('facets__submit--disabled');
        applyBtn.removeAttribute('disabled');
        applyBtn.setAttribute('aria-disabled', 'false');
      } else {
        applyBtn.classList.add('facets__submit--disabled');
        applyBtn.setAttribute('disabled', '');
        applyBtn.setAttribute('aria-disabled', 'true');
      }
    }
  },
  updateFilterBadges () {
    const container = this.facets.container;
    if (!container) return;
    
    const details = container.querySelectorAll('.facets__details');
    details.forEach((detail, index) => {
      const checkboxes = detail.querySelectorAll('input[type="checkbox"]:checked');
      let badge = detail.querySelector('.facets__count-badge');
      
      if (checkboxes.length > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'facets__count-badge';
          const title = detail.querySelector('.facets__details-title');
          if (title) title.appendChild(badge);
        }
        badge.textContent = checkboxes.length;
        badge.style.display = 'inline-block';
      } else {
        if (badge) {
          badge.textContent = '';
          badge.style.display = 'none';
        }
      }
    });
  },
  buildSortAndFilter() {
    let sort = null;
    switch (this.sortBy.value) {
      case "price-descending":
        sort = { field: "price", order: "desc" };
        break;
      case "price-ascending":
        sort = { field: "price", order: "asc" };
        break;
      case "created-descending":
        sort = { field: "datePublished", order: "desc" };
        break;
      default:
        sort = null;
        break;
    }

    const filter = (this.facets.list || [])
      .filter(f => Array.isArray(f.value) && f.value.length > 0)
      .map(f => ({ field: f.field, value: f.value }));

    return { sort, filter };
  },
  renderFacetsFromResponse(response) {
    if (!response?.products?.facets || response.products.facets.length === 0) return;

    const tallaOrder = ["XCH", "CH", "M", "G", "XG", "CHM", "MG", "UNITALLA", "SIN TALLA"];

    // Limpia UI (pero NO borra tu state interno)
    this.facets.container.innerHTML = "";

    // --- Color reverse map (variant -> groupLabel) ---
    const COLOR_REVERSE_MAP = (() => {
      const m = new Map();
      for (const [groupLabel, variants] of Object.entries(COLOR_FILTER_MAP)) {
        for (const v of variants) {
          const key = (v ?? "").toString().toUpperCase().trim();
          if (!key) continue;
          if (!m.has(key)) m.set(key, groupLabel);
        }
      }
      return m;
    })();

    const normalize = (s) => (s ?? "").toString().toUpperCase().trim();

    // Helpers para saber si un checkbox debe ir checked
    const isValueChecked = (field, rawValue) => {
      const f = this.facets.list.find((x) => x.field === field);
      if (!f) return false;
      const v = normalize(rawValue);
      return (f.value || []).includes(v);
    };

    const isGroupChecked = (field, groupLabel) => {
      const set = this.facets.colorGroupsByField?.[field];
      if (!set) return false;
      // Guardamos el label tal cual (Amarillo) o uppercase según tu convención.
      // Aquí aceptamos ambos:
      return set.has(groupLabel) || set.has((groupLabel ?? "").toString().toUpperCase().trim());
    };

    const buildFacetItemsHtml = (customFacet) => {
      const isColorFacet = (customFacet.name || "").toString().toLowerCase() === "color";
      const field = customFacet.field;

      if (!isColorFacet) {
        return (customFacet.data || [])
          .slice()
          .sort((a, b) => {
            if (field !== "skus.customFields.talla") return 0;
            const aIndex = tallaOrder.indexOf(normalize(a.value));
            const bIndex = tallaOrder.indexOf(normalize(b.value));
            if (aIndex === -1 && bIndex === -1) return 0;
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;
            return aIndex - bIndex;
          })
          .map((facet) => {
            const raw = (facet?.value ?? "").toString();
            const checkedAttr = isValueChecked(field, raw) ? "checked" : "";

            return `
              <li class="list-menu__item facets__item" title="${raw}">
                <label class="facets-checkbox">
                  <input type="checkbox" class="facets-checkbox__hide"
                    ${checkedAttr}
                    onchange="category.facets.set('${field}', '${raw}', this.checked)">
                  <span class="facets-checkbox__marker">
                    <svg width="12" height="10" class="icon icon-facets-checkmark" viewBox="0 0 12 10">
                      <path d="M2 4.82353L4.76923 8L10 2" stroke="currentColor" stroke-width="2"/>
                    </svg>
                  </span>
                  <span class="facets-checkbox__label">${raw}</span>
                </label>
              </li>
            `;
          })
          .join("");
      }

      // --- Agrupar colores por label ---
      const groups = new Map();

      for (const facet of customFacet.data || []) {
        const raw = (facet?.value ?? "").toString().trim();
        if (!raw) continue;

        const key = normalize(raw);
        const groupLabel = COLOR_REVERSE_MAP.get(key);
        if (!groupLabel) continue;

        if (!groups.has(groupLabel)) groups.set(groupLabel, new Set());
        groups.get(groupLabel).add(raw);
      }

      const orderedGroupLabels = Array.from(groups.keys()).sort((a, b) => a.localeCompare(b, "es"));

      return orderedGroupLabels
        .map((label) => {
          const rawList = Array.from(groups.get(label));
          const title = rawList.join(", ");

          const checkedAttr = isGroupChecked(field, label) ? "checked" : "";

          return `
            <li class="list-menu__item facets__item" title="${title}">
              <label class="facets-checkbox">
                <input type="checkbox" class="facets-checkbox__hide"
                  ${checkedAttr}
                  onchange="category.facets.set('${field}', '${label}', this.checked, true)">
                <span class="facets-checkbox__marker">
                  <svg width="12" height="10" class="icon icon-facets-checkmark" viewBox="0 0 12 10">
                    <path d="M2 4.82353L4.76923 8L10 2" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </span>
                <span class="facets-checkbox__label">${label}</span>
              </label>
            </li>
          `;
        })
        .join("");
    };

    // Pintar todos los facets (excluyendo el que ya excluías)
    for (const customFacet of response.products.facets) {
      if (customFacet.name === "shasa-color") continue;

      const itemsHtml = buildFacetItemsHtml(customFacet);

      this.facets.container.innerHTML += `
        <details class="facets__details">
          <summary>
            <span class="facets__details-title">
              ${customFacet.name}
              <span class="facets__count-badge" style="display:none;"></span>
            </span>
            <svg class="icon icon-filter-two" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 1.5L6 5.5L2 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="square"/>
            </svg>
          </summary>

          <fieldset class="facets-wrap parent-wrap">
            <ul class="facets__list">
              ${itemsHtml}
            </ul>
          </fieldset>
        </details>
      `;
    }

    // Botón Apply (igual que antes)
    const applyBtn = this.facets.container?.parentElement?.querySelector('button[type="button"].facets__submit');
    if (applyBtn) {
      applyBtn.className = 'button button--primary button--full-width facets-apply-btn facets__submit facets__submit--disabled';
      applyBtn.setAttribute('disabled', '');
      applyBtn.setAttribute('aria-disabled', 'true');
      // Evita doble bind si renderizas varias veces
      applyBtn.onclick = null;
      applyBtn.addEventListener('click', category.facets.applyFilters);
    }

    // Si tienes estado ya seleccionado desde URL, esto actualizará badges y habilitará botón
    category.logSelectedFilters();
    category.updateFilterBadges();
  },
  async loadUntil(targetLoaded) {
    if (!targetLoaded || targetLoaded <= this.size) {
      console.log('Debug - carga desde loadUntil')
      await this.loadProducts();
      return;
    }

    const CHUNK_MAX = 60;

    while (this.from < targetLoaded) {
      const remaining = targetLoaded - this.from;
      const nextSize = Math.min(CHUNK_MAX, remaining);

      const originalSize = this.size;
      this.size = nextSize;

      console.log('Debug - carga desde loadUntil con chunk')
      const res = await this.loadProducts();
      this.size = originalSize;

      if (!res || !res.products || !res.products.hits || res.products.hits.length === 0) break;
    }
  },
  loadFacetsOnly() {
    if (this.isLoading) return Promise.resolve(null);
    this.isLoading = true;

    const { sort, filter } = this.buildSortAndFilter();

    return new Promise((resolve) => {
      nostojs((api) => {
        let savedResponse = null;

        api.search({
          products: {
            categoryId: String(this.id),
            facets: ["*"],
            fields: ["name", "url","imageUrl"],
            size: 1,
            from: 0,
            ...(sort ? { sort } : {}),
            ...(filter.length ? { filter } : {}),
          }
        }, { track: "category", redirect: true })
        .then((response) => {
          savedResponse = response;
          this.renderFacetsFromResponse(response);
        })
        .catch((err) => {
          console.error("loadFacetsOnly error:", err);
          savedResponse = null;
        })
        .finally(() => {
          this.isLoading = false;
          console.log("Debug - Termina loadFacets");
          if (!this._initialized) this._initialized = true;
          resolve(savedResponse);
        });
      });
    });
  },
  loadProducts () {
    if (this.isLoading) return Promise.resolve(null);
    this.isLoading = true
    const { sort, filter } = this.buildSortAndFilter();
    return new Promise((resolve) => {
      nostojs(api => {
          api.search({
              products: {
                  categoryId: String(this.id),
                  facets:["*"],
                  fields: ['name', "url","imageUrl"],
                  size: this.size,
                  from: this.from,
                  sort: sort,
                  filter:filter
              }
          }, {
              track: 'category',
              redirect: true
          }).then(response => {
            console.log('Debug - respuesta del request')

            const total_productos = response.products.total;
           
            const productCountDiv = document.getElementById('ProductCount');
            if (productCountDiv) {
              productCountDiv.textContent =  total_productos + " Productos";
            }


            console.log(response)
            if (!this._initialized && response.products.facets.length > 0) {
                this.renderFacetsFromResponse(response)
            }
            if (response.products.hits.length > 0) {
              this.indexHits(response.products.hits);
              const productsIds = response.products.hits.map((product) => product.productId)
              this.from += productsIds.length
              this.setUrlParam("loaded", this.from);
              for (const rawPid of productsIds) {
                const pid = String(rawPid).split("/").pop();
                const id = `card-${pid}`;
                const duplicates = document.querySelectorAll(`#${CSS.escape(id)}`);
                if (duplicates.length > 1) {
                  console.warn("DUPLICATE PLACEHOLDERS DETECTED:", id, duplicates);
                }
                let container = document.getElementById(id);

                if (!container) {
                  container = document.createElement("div");
                  container.id = id;
                  this.container.appendChild(container);
                } else {
                  container.replaceChildren(); 
                }
                new Card(pid, id, "category");
              }
            } else if (this.from == 0) {
              this.container.innerHTML = "<h2>Sin resultados</h2>";
            }
            savedResponse = response;
          })
          .catch((err) => {
            console.error("loadProducts error:", err);
            savedResponse = null;
          })
          .finally(() => {
            this.isLoading = false;
            if( !this._initialized ) {
                this._initialized = true
            }
            resolve(savedResponse);
          });
      });
    });
  },
}

if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}
category.bindPlpNavigationTracking();

const COLOR_FILTER_MAP = {
  Amarillo: [
    "AMARILLO",
    "AMARILLO COMBO",
    "AMARILLO NEON",
    "AMARILLO OBSCURO",
    "AMARILLO PASTEL",
    "MANGO",
    "MOSTAZA",
    "MOSTAZA COMBO",
    "MOSTAZA OBSCURO"
  ],
  Azul: [
    "ACID LIGHT",
    "ACID MEDIO",
    "ACID WASH",
    "AZUL",
    "AZUL BRILLANTE",
    "AZUL CIELO",
    "AZUL COMBO",
    "AZUL ELECTRICO",
    "AZUL PASTEL",
    "AZUL PATO",
    "AZUL PITUFO",
    "AZUL REY",
    "AZUL REY COMBO",
    "BLEACHED",
    "DARK WASH",
    "INDIGO",
    "LIGHT WASH",
    "MARINO",
    "MARINO COMBO",
    "MEDIUM WASH",
    "STONE",
    "STONE LIGHT",
    "STONE MEDIO"
  ],
  Beige: [
    "ARENA",
    "BEIGE",
    "CREMA",
    "HUESO",
    "HUESO COMBO",
    "NUDE"
  ],
  Blanco: [
    "BLANCO",
    "BLANCO COMBO",
    "TRANSPARENTE"
  ],
  Cafe: [
    "AMBAR",
    "BRONCE",
    "CAFE",
    "CAFE COMBO",
    "CAFE OBSCURO",
    "CAMELLO",
    "CHOCOLATE",
    "COBRE",
    "GREIGE",
    "KHAKI",
    "KHAKI COMBO",
    "TAN",
    "TAUPE"
  ],
  Gris: [
    "GRIS",
    "GRIS CLARO",
    "GRIS COMBO",
    "GRIS JASPE",
    "GRIS OBSCURO",
    "HEMATITA",
    "PETROLEO"
  ],
  Metalicos: [
    "IRIDISCENTE",
    "ORO",
    "ORO COMBO",
    "ORO ROSA",
    "PLATA",
    "PLATA COMBO"
  ],
  Morado: [
    "LAVANDA",
    "LILA",
    "LILA OBSCURO",
    "MALVA",
    "MORADO",
    "MORADO BRILLANTE",
    "MORADO COMBO",
    "UVA"
  ],
  Multicolor: [
    "MULTICOLOR",
    "MULTICOLOR B&N",
    "MULTICOLOR BRILLANTE",
    "MULTICOLOR NEON",
    "MULTICOLOR OTOÑAL",
    "MULTICOLOR PASTEL"
  ],
  Naranja: [
    "CORAL",
    "CORAL COMBO",
    "DURAZNO",
    "MANDARINA",
    "NARANJA",
    "NARANJA BRILLANTE",
    "NARANJA COMBO",
    "NARANJA NEON",
    "NARANJA OBSCURO"
  ],
  Negro: [
    "ACID DARK",
    "NEGRO",
    "NEGRO BLANCO",
    "NEGRO COMBO"
  ],
  Rojo: [
    "CIRUELA",
    "LADRILLO",
    "ROJO",
    "ROJO AMAPOLA",
    "ROJO CEREZA",
    "ROJO COMBO",
    "ROJO QUEMADO",
    "ROJO TOMATE",
    "VINO",
    "VINO COMBO"
  ],
  Rosa: [
    "BLUSH",
    "BUGAMBILIA",
    "FIUSHA",
    "FIUSHA COMBO",
    "MAGENTA",
    "MARSALA",
    "PALO DE ROSA",
    "ROSA",
    "ROSA BRILLANTE",
    "ROSA COMBO",
    "ROSA NEON",
    "ROSA PASTEL",
    "TURQUESA",
    "TURQUESA BRILLANTE"
  ],
  Verde: [
    "JADE",
    "MENTA",
    "MENTA COMBO",
    "OLIVO",
    "OLIVO COMBO",
    "SAGE",
    "VERDE",
    "VERDE BOTELLA",
    "VERDE BRILLANTE",
    "VERDE CAZADOR",
    "VERDE CLARO",
    "VERDE COMBO",
    "VERDE LIMA",
    "VERDE MANZANA",
    "VERDE NEON",
    "VERDE OBSCURO",
    "VERDE PASTO"
  ]
};